import { deleteListing, hideListingEndpoint, postCreateWarehouse, postUpdateWarehouse,
   postDeleteWarehouse ,postControlWarehouse,postGetAllWarehouses}
 from '../../util/api';
import { denormalisedEntities, updatedEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { createImageVariantConfig } from '../../util/sdkLoader';
import { parse } from '../../util/urlHelpers';

// Pagination page size might need to be dynamic on responsive page layouts
// Current design has max 3 columns 42 is divisible by 2 and 3
// So, there's enough cards to fill all columns on full pagination pages
const RESULT_PAGE_SIZE = 42;

// ================ Action types ================ //

export const ADD_WAREHOUSE = 'app/ManageWarehousePage/ADD_WAREHOUSE';
export const ADD_WAREHOUSE_LOADING = 'app/ManageWarehousePage/ADD_WAREHOUSE_LOADING';
export const ADD_WAREHOUSE_ERROR = 'app/ManageWarehousePage/ADD_WAREHOUSE_ERROR';

// ================ Action types ================ //

export const GET_WAREHOUSES = 'app/ManageWarehousePage/GET_WAREHOUSES';
export const GET_WAREHOUSES_LOADING = 'app/ManageWarehousePage/GET_WAREHOUSES_LOADING';
export const GET_WAREHOUSES_ERROR = 'app/ManageWarehousePage/GET_WAREHOUSES_ERROR';

export const GET_LISTINGS_WAREHOUSES = 'app/ManageWarehousePage/GET_LISTINGS_WAREHOUSES';
export const GET_LISTINGS_WAREHOUSES_LOADING = 'app/ManageWarehousePage/GET_LISTINGS_WAREHOUSES_LOADING';
export const GET_LISTINGS_WAREHOUSES_ERROR = 'app/ManageWarehousePage/GET_LISTINGS_WAREHOUSES_ERROR';


export const UPDATE_WAREHOUSES = 'app/ManageWarehousePage/UPDATE_WAREHOUSES';
export const UPDATE_WAREHOUSES_LOADING = 'app/ManageWarehousePage/UPDATE_WAREHOUSES_LOADING';
export const UPDATE_WAREHOUSES_ERROR = 'app/ManageWarehousePage/UPDATE_WAREHOUSES_ERROR';



// ================ Reducer ================ //

const initialState = {
  addWarehouseLoading: false,
  addWarehouseError: null,
  warehouses: [], 
  warehousesLoading: false,
  warehousesError: null, 
  listingWarehouses:[], 
  listingWarehousesLoading:false, 
  listingWarehousesError:null,
  updateWarehouseInProgress :false,
  updateWarehouseError : null,
  updateWarehouseInProgressId : null,
};

const manageWarehousePageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_WAREHOUSE:
      // const transactionRef = { id: payload.data.data.id, type: 'transaction' };
      return { ...state, addWarehouseLoading: false };
    case ADD_WAREHOUSE_LOADING:
      return { ...state, addWarehouseLoading: true };
    case ADD_WAREHOUSE_ERROR:
      return { ...state, addWarehouseLoading: false, addWarehouseError: payload };

        // Handle fetching warehouses
    case GET_WAREHOUSES_LOADING:
      return { ...state, warehousesLoading: true };
    case GET_WAREHOUSES:
      return { ...state, warehouses: payload, warehousesLoading: false };
    case GET_WAREHOUSES_ERROR:
      return { ...state, warehousesError: payload, warehousesLoading: false };

      // listings author info
      case GET_LISTINGS_WAREHOUSES_LOADING:
      return { ...state, listingWarehousesLoading: true };
    case GET_LISTINGS_WAREHOUSES:
      return { ...state, listingWarehouses: payload, listingWarehousesLoading: false };
    case GET_LISTINGS_WAREHOUSES_ERROR:
      return { ...state, listingWarehousesError: payload, listingWarehousesLoading: false };


      case UPDATE_WAREHOUSES:
      return { ...state, updateWarehouseInProgress: false };
    case UPDATE_WAREHOUSES_LOADING:
      return { ...state,  updateWarehouseInProgress: true ,updateWarehouseInProgressId: payload};
    case UPDATE_WAREHOUSES_ERROR:
      return { ...state, updateWarehouseError: payload, updateWarehouseInProgress: false };

    default:
      return state;
  }
};

export default manageWarehousePageReducer;

// ================ Selectors ================ //

// ================ Action creators ================ //

// This works the same way as addMarketplaceEntities,
// but we don't want to mix own listings with searched listings
// (own listings data contains different info - e.g. exact location etc.)

export const addWarehouseSuccess = transaction => ({
  type: ADD_WAREHOUSE,
  payload: transaction.data,
});

export const addWarehouseError = error => ({
  type: ADD_WAREHOUSE_ERROR,
  error: true,
  payload: error,
});

// ================ Action creators ================ //

export const getWarehousesSuccess = (warehouses) => ({
  type: GET_WAREHOUSES,
  payload: warehouses,
});

export const getWarehousesError = (error) => ({
  type: GET_WAREHOUSES_ERROR,
  payload: error,
});

export const getWarehousesLoading = () => ({
  type: GET_WAREHOUSES_LOADING,
});


export const getListingsWarehousesSuccess = (warehouses) => ({
  type: GET_LISTINGS_WAREHOUSES,
  payload: warehouses,
});

export const getListingsWarehousesError = (error) => ({
  type: GET_LISTINGS_WAREHOUSES_ERROR,
  payload: error,
});

export const getListingsWarehousesLoading = () => ({
  type: GET_LISTINGS_WAREHOUSES_LOADING,
});

export const updateWarehousesuccess = () => ({
  type: UPDATE_WAREHOUSES,
});

export const updateWarehouseLoading = (id) => ({
  type: UPDATE_WAREHOUSES_LOADING,
  payload: id,
});

export const updateWarehouseError = () => ({
type: UPDATE_WAREHOUSES_ERROR
});


// export const addWareHouse = listing => async (dispatch, getState, sdk) => {
//   dispatch({ type: ADD_WAREHOUSE_LOADING });

//   try {
//     await sdk.currentUser
//       .updateProfile({ publicData: listing }, { expand: true })
//       .then(response => {
//         dispatch(addWarehouseSuccess(response.data));
//         window.location.reload();
//       })
//       .catch(e => {
//         dispatch(addWarehouseError(storableError(e)));
//       });
//   } catch (e) {
//     dispatch(addWarehouseError(storableError(e)));
//   }
// };

export const addWareHouse = warehouse => async (dispatch, getState) => {
  dispatch({ type: ADD_WAREHOUSE_LOADING });

  try {
    const state = getState();
    const userId = state.user.currentUser?.id?.uuid;

    const payload = {
      ...warehouse,
      UserId: userId, 
    };
    const response =await postControlWarehouse(payload)
     

    dispatch(addWarehouseSuccess(response.data));
    dispatch(getWarehouses());
    window.location.reload();
  } catch (e) {
    console.error('Add warehouse failed', e);
    dispatch(addWarehouseError(e));
  }
};


export const deleteWarehouse = ({ id, userId }) => async (dispatch, getState) => {
  dispatch({ type: ADD_WAREHOUSE_LOADING });
  try {
    await postDeleteWarehouse({ id, userId });
    dispatch(getWarehouses());
    // window.location.reload();
  } catch (e) {
    dispatch(addWarehouseError(e));
  }
};

// Fetch warehouses for a specific user
export const getWarehouses = () => async (dispatch, getState) => {
  dispatch(getWarehousesLoading()); 

  try {
    const state = getState();
    const userId = state.user.currentUser?.id?.uuid;

 

    const response = await postGetAllWarehouses({ UserId: userId });
    dispatch(getWarehousesSuccess(response.data));
  } catch (e) {
    console.error('Fetch warehouses failed', e);
    dispatch(getWarehousesError(e));
  }
};

export const getAuthorWarehouses = (authorId) => async (dispatch, getState) => {
  dispatch(getListingsWarehousesLoading()); 

  try {
    const state = getState();
    // const userId = state.user.currentUser?.id?.uuid;

 

    const response = await postGetAllWarehouses({ UserId: authorId });
    dispatch(getListingsWarehousesSuccess(response.data));
  } catch (e) {
    console.error('Fetch author warehouses failed', e);
    dispatch(getListingsWarehousesError(e));
  }
};

export const updateWarehouseWithSubUserIds = ({ id, userId, subuserId, action}) => async (dispatch, getState) => {
   dispatch(updateWarehouseLoading(subuserId)) ;
  try {
   await postUpdateWarehouse(({ id, userId, subuserId ,action}));
    dispatch(getWarehouses());
    dispatch(updateWarehousesuccess());
  }
catch(e){
   console.error('failed to update warehouse with subUser id', e);
   dispatch(updateWarehouseError);
}
 
}